import React, { FC } from 'react';

import {
  perfilVoebiz,
  account,
  categoryIcon,
  data,
  extract,
  fly,
  team,
  more,
  points,
  retroactive,
  accountOrange,
  categoryOrange,
  dataOrange,
  extractOrange,
  flyOrange,
  teamOrange,
  moreOrange,
  pointsOrange,
  retroactiveOrange,
  clubExtract,
  clubExtractOrange,
  club,
  clubOrange,
  vale,
  valeOrange,
  arrow,
} from 'utils/icons';

import { Tier } from 'services/api/tier/types';

import { getClassWithTheme } from 'helpers';

import { useTheme } from '../../containers/MyAccount';

export interface SidebarProps {
  user: string;
  voeBizNumber: string;
  tier: string;
  isClubSmls: boolean;
  tierData: Tier;
  isValeMilhas: boolean;
}

interface SubmenuItem {
  href: string;
  title: string;
  id: string;
  iconOrange?: string;
  iconGrey?: string;
}

interface MenuItem {
  href?: string;
  title: string;
  id: string;
  iconOrange: string;
  iconGrey: string;
  submenu?: SubmenuItem[];
}

const Sidebar: FC<SidebarProps> = ({ user, voeBizNumber, tierData, tier, isClubSmls, isValeMilhas }) => {
  const theme = useTheme();

  const isExclusive = tier.toLowerCase() === 'exclusive';

  const isActiveMenu = (menuHref: string) => {
    const { pathname } = window.location;
    return pathname === menuHref ? 'active' : '';
  };

  // Href constants
  const hrefMinhaConta = '/minha-conta';
  const hrefDadosDaConta = '/minha-conta/alterar-dados';
  const hrefMinhaCategoria = '/minha-conta/minha-categoria';
  const hrefExtratoVoebiz = '/minha-conta/extrato';
  const hrefExtratoClubeSmiles = '/extrato-clube-corporativo';
  const hrefMeusVoos = '/minha-conta/meus-voos';
  const hrefClubeSmiles = '/clube-corporativo';
  const hrefPontosRetroativos = '/minha-conta/solicitar-pontos';
  const hrefEquipe = '/beneficiarios';
  const hrefResgatarPontos = '/home';
  const hrefPremiarMilhasInst = '/gestao-premiar-milhas';
  const hrefPremiarMilhasGestao = '/gestao-premiar-milhas';

  // ID constants
  const idMinhaConta = 'vbz-my-category-my-account';
  const idDadosDaConta = 'vbz-my-category-my-data';
  const idMinhaCategoria = 'vbz-my-category-my-category';
  const idExtratoVoebiz = 'vbz-my-category-my-extract';
  const idExtratoClubeSmiles = 'vbz-club-extract';
  const idMostrarMais = 'vbz-my-category-more';
  const idPontosRetroativos = 'vbz-my-category-retroactive';
  const idEquipe = 'vbz-my-category-my-team';
  const idResgatarPontos = 'vbz-my-category-my-points';
  const idMeusVoos = 'vbz-my-category-my-flights';
  const idClubeSmiles = 'vbz-club';
  const idPremiarMilhasInst = 'vbz-my-category-gift-miles-inst';
  const idPremiarMilhasGestao = 'vbz-my-category-gift-miles-client';

  // Title constants

  const titleMinhaConta = 'Minha conta';
  const titleDadosDaConta = 'Dados da conta';
  const titleMinhaCategoria = 'Minha categoria';
  const titleExtratoVoebiz = 'Extrato VoeBiz';
  const titleExtratoClubeSmiles = 'Extrato Clube Smiles';
  const titleMostrarMais = 'Mostrar mais';
  const titlePontosRetroativos = 'Pontos retroativos';
  const titleEquipe = 'Equipe';
  const titleResgatarPontos = 'Resgatar pontos';
  const titleMeusVoos = 'Meus voos';
  const titleClubeSmiles = 'Clube Smiles';
  const titlePremiarMilhasInst = 'Premiar milhas';
  const titlePremiarMilhasGestao = 'Premiar milhas';

  const menuItems: { condition: boolean; items: MenuItem[] }[] = [
    {
      condition: !isClubSmls && !isExclusive && !isValeMilhas,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefMeusVoos,
          id: idMeusVoos,
          title: titleMeusVoos,
          iconGrey: fly,
          iconOrange: flyOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },
        {
          id: idMostrarMais,
          title: titleMostrarMais,
          iconGrey: more,
          iconOrange: moreOrange,
          submenu: [
            {
              href: hrefPontosRetroativos,
              id: idPontosRetroativos,
              title: titlePontosRetroativos,
              iconGrey: retroactive,
              iconOrange: retroactiveOrange,
            },
            {
              href: hrefEquipe,
              id: idEquipe,
              title: titleEquipe,
              iconGrey: team,
              iconOrange: teamOrange,
            },
            {
              href: hrefResgatarPontos,
              id: idResgatarPontos,
              title: titleResgatarPontos,
              iconGrey: points,
              iconOrange: pointsOrange,
            },
            {
              href: hrefPremiarMilhasInst,
              id: idPremiarMilhasInst,
              title: titlePremiarMilhasInst,
              iconGrey: vale,
              iconOrange: valeOrange,
            },
          ],
        },
      ],
    },
    {
      condition: isClubSmls && !isExclusive && !isValeMilhas,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefExtratoClubeSmiles,
          id: idExtratoClubeSmiles,
          title: titleExtratoClubeSmiles,
          iconGrey: clubExtract,
          iconOrange: clubExtractOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },
        {
          id: idMostrarMais,
          title: titleMostrarMais,
          iconGrey: more,
          iconOrange: moreOrange,
          submenu: [
            {
              href: hrefPontosRetroativos,
              id: idPontosRetroativos,
              title: titlePontosRetroativos,
              iconGrey: retroactive,
              iconOrange: retroactiveOrange,
            },
            {
              href: hrefMeusVoos,
              id: idMeusVoos,
              title: titleMeusVoos,
              iconGrey: fly,
              iconOrange: flyOrange,
            },
            {
              href: hrefEquipe,
              id: idEquipe,
              title: titleEquipe,
              iconGrey: team,
              iconOrange: teamOrange,
            },
            {
              href: hrefResgatarPontos,
              id: idResgatarPontos,
              title: titleResgatarPontos,
              iconGrey: points,
              iconOrange: pointsOrange,
            },
            {
              href: hrefPremiarMilhasInst,
              id: idPremiarMilhasInst,
              title: titlePremiarMilhasInst,
              iconGrey: vale,
              iconOrange: valeOrange,
            },
          ],
        },
      ],
    },
    {
      condition: isClubSmls && !isExclusive && isValeMilhas,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefPremiarMilhasGestao,
          id: idPremiarMilhasGestao,
          title: titlePremiarMilhasGestao,
          iconGrey: vale,
          iconOrange: valeOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },
        {
          href: '#',
          id: idMostrarMais,
          title: titleMostrarMais,
          iconGrey: more,
          iconOrange: moreOrange,
          submenu: [
            {
              href: hrefExtratoClubeSmiles,
              id: idExtratoClubeSmiles,
              title: titleExtratoClubeSmiles,
              iconGrey: clubExtract,
              iconOrange: clubExtractOrange,
            },
            {
              href: hrefPontosRetroativos,
              id: idPontosRetroativos,
              title: titlePontosRetroativos,
              iconGrey: retroactive,
              iconOrange: retroactiveOrange,
            },
            {
              href: hrefMeusVoos,
              id: idMeusVoos,
              title: titleMeusVoos,
              iconGrey: fly,
              iconOrange: flyOrange,
            },
            {
              href: hrefEquipe,
              id: idEquipe,
              title: titleEquipe,
              iconGrey: team,
              iconOrange: teamOrange,
            },
            {
              href: hrefResgatarPontos,
              id: idResgatarPontos,
              title: titleResgatarPontos,
              iconGrey: points,
              iconOrange: pointsOrange,
            },
          ],
        },
      ],
    },
    {
      condition: !isClubSmls && !isExclusive && isValeMilhas,
      items: [
        {
          href: hrefMinhaConta,
          id: idMinhaConta,
          title: titleMinhaConta,
          iconGrey: account,
          iconOrange: accountOrange,
        },
        {
          href: hrefDadosDaConta,
          id: idDadosDaConta,
          title: titleDadosDaConta,
          iconGrey: data,
          iconOrange: dataOrange,
        },
        {
          href: hrefMinhaCategoria,
          id: idMinhaCategoria,
          title: titleMinhaCategoria,
          iconGrey: categoryIcon,
          iconOrange: categoryOrange,
        },
        {
          href: hrefExtratoVoebiz,
          id: idExtratoVoebiz,
          title: titleExtratoVoebiz,
          iconGrey: extract,
          iconOrange: extractOrange,
        },
        {
          href: hrefPremiarMilhasGestao,
          id: idPremiarMilhasGestao,
          title: titlePremiarMilhasGestao,
          iconGrey: vale,
          iconOrange: valeOrange,
        },
        {
          href: hrefClubeSmiles,
          id: idClubeSmiles,
          title: titleClubeSmiles,
          iconGrey: club,
          iconOrange: clubOrange,
        },
        {
          href: '#',
          id: idMostrarMais,
          title: titleMostrarMais,
          iconGrey: more,
          iconOrange: moreOrange,
          submenu: [
            {
              href: hrefPontosRetroativos,
              id: idPontosRetroativos,
              title: titlePontosRetroativos,
              iconGrey: retroactive,
              iconOrange: retroactiveOrange,
            },
            {
              href: hrefEquipe,
              id: idEquipe,
              title: titleEquipe,
              iconGrey: team,
              iconOrange: teamOrange,
            },
            {
              href: hrefResgatarPontos,
              id: idResgatarPontos,
              title: titleResgatarPontos,
              iconGrey: points,
              iconOrange: pointsOrange,
            },
            {
              href: hrefMeusVoos,
              id: idMeusVoos,
              title: titleMeusVoos,
              iconGrey: fly,
              iconOrange: flyOrange,
            },
          ],
        },
      ],
    },
    {
      condition: isExclusive,
      items: [],
    },
  ];
  const renderMenuItem = (item: MenuItem) => (
    <li key={item.id} className={`my-account-sidebar__menu-item-container${isActiveMenu(item.id || '')}`}>
      <a href={item.href} className="my-account-sidebar__menu-item account-link">
        <i className="my-account-sidebar__icon--account-grey">
          <img src={item.iconGrey} alt={item.title} />
        </i>
        <i className="my-account-sidebar__icon--account-orange">
          <img src={item.iconOrange} alt={item.title} />
        </i>
        {item.title}
      </a>
    </li>
  );

  const renderMenu = () => {
    if (isExclusive) {
      return null;
    }
    return (
      <ul className="my-account-sidebar__menu">
        {menuItems.map((menu, index) => {
          if (menu.condition && !isExclusive) {
            // Separar o item "Mostrar mais" do resto dos itens
            const moreItem = menu.items.find((item) => item.id === idMostrarMais);
            const otherItems = menu.items.filter((item) => item.id !== idMostrarMais);

            return (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={index}>
                {otherItems.map((item) => renderMenuItem(item))}

                <li className="my-account-sidebar__menu-item-container my-account-sidebar__menu-item--more">
                  <a href="#" className="my-account-sidebar__menu-item-link">
                    <i className="my-account-sidebar__icon--more-grey">
                      <img src={more} alt="more" />
                    </i>
                    <i className="my-account-sidebar__icon--more-orange">
                      <img src={moreOrange} alt="more" />
                    </i>
                    Mostrar mais
                    <i className="my-account-sidebar__icon--more-arrow">
                      <img src={arrow} alt="more" />
                    </i>
                  </a>

                  <ul className="my-account-sidebar__submenu">
                    {moreItem?.submenu?.map((subItem: SubmenuItem) => (
                      <li key={subItem.id} className="my-account-sidebar__submenu-item-container">
                        <a href={subItem.href} className="my-account-sidebar__submenu-item">
                          <i className="my-account-sidebar__icon--account-grey">
                            <img src={subItem.iconGrey} alt={subItem.title} />
                          </i>
                          <i className="my-account-sidebar__icon--account-orange">
                            <img src={subItem.iconOrange} alt={subItem.title} />
                          </i>
                          {subItem.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
              </React.Fragment>
            );
          }
          return null;
        })}
      </ul>
    );
  };

  return (
    <div className={`my-account-sidebar ${tierData.tierList[0].name.toLowerCase().replace(' ', '-')}`}>
      <div className={getClassWithTheme('my-account-sidebar__header', theme)}>
        <i className="my-account-sidebar__header__icon--perfil">
          <img src={perfilVoebiz} alt="perfil" />
        </i>
        <h2 className="my-account-sidebar__header__client-name">{user}</h2>
        <p className="my-account-sidebar__header__client-id">Número VoeBiz: {voeBizNumber}</p>
      </div>
      {renderMenu()}
    </div>
  );
};

export default Sidebar;
